import React from "react";
import Button from "../../../layout/Button";

export function CustomPagination({ pageSize, page, total, onNext, OnPrev }) {
  
  const handleNext = (pageSize) => {
    const pSize = pageSize.pageSize10 ? 10 : pageSize.pageSize50 ? 50 : 100;
    if (total / pSize > page) {
      onNext(page + 1, pSize);
    }
  };

  const handlePrev = (pageSize) => {
    const pSize = pageSize.pageSize10 ? 10 : pageSize.pageSize50 ? 50 : 100;

    if (page > 1) {
      OnPrev(page - 1, pSize);
    }
  };

  return (
    <div className="d-flex pagination-button-container">
      <p>
        <Button variant="previous-btn" onClick={() => handlePrev(pageSize)} />
      </p>
      {pageSize.pageSize10 && (
        <p className="next-page-pg custom-left-arrow">
          Page <span className="text-primary">{page}</span> of{" "}
          {Math.ceil(total / 10)}
        </p>
      )}
      {pageSize.pageSize50 && (
        <p className="next-page-pg custom-left-arrow">
          Page <span className="text-primary">{page}</span> of{" "}
          {Math.ceil(total / 50)}
        </p>
      )}
      {pageSize.pageSize100 && (
        <p className="next-page-pg custom-left-arrow">
          Page <span className="text-primary">{page}</span> of{" "}
          {Math.ceil(total / 100)}
        </p>
      )}
      <p>
        <Button
          id="rmDomesticListing_next"
          variant="next-btn"
          onClick={() => handleNext(pageSize)}
        />
      </p>
    </div>
  );
}
